var map = {
	"./blankCanvas.png": 12,
	"./electionMap.png": 31,
	"./hero.jpg": 32,
	"./holstee-manifesto-full.png": 33,
	"./holstee-manifesto.png": 34,
	"./jubilee-austen-full.png": 35,
	"./jubilee-austen.png": 36,
	"./logo.png": 13,
	"./lolcat-clock.png": 37,
	"./magic8Ball.png": 38,
	"./me.jpg": 14,
	"./nameTag.png": 39,
	"./page-header.png": 40,
	"./pontoon.png": 41,
	"./reactMovie.png": 42,
	"./roguePickings.png": 43,
	"./socialIdeas.png": 15,
	"./stickyNotes.png": 44,
	"./tribute-page.png": 45,
	"./unplugged.png": 46,
	"./work-page-header.jpg": 47
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9;